import React from "react";

import { Box, Typography, TextField } from "@mui/material";
import JerseyIcon from "../Components/JerseyIcon";
import { RosterPlayer } from "../../../../types/LogTypes";

interface PlayerSelectionProps {
  title: string;
  players: RosterPlayer[];
  selectedPlayer: RosterPlayer | RosterPlayer[] | null;
  jerseyNumber: string | string[];
  maxDisplayedPlayers: number;
  maxPlayersPerRow?: number;
  handlePlayerSelection: (player: RosterPlayer) => void;
  handleJerseyNumberChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export const PlayerSelection = ({
  title,
  players,
  selectedPlayer,
  jerseyNumber,
  maxDisplayedPlayers,
  maxPlayersPerRow = 8,
  handlePlayerSelection,
  handleJerseyNumberChange,
}: PlayerSelectionProps) => {
  const uniquePlayers = players
    .filter(
      (player, index, self) =>
        index ===
        self.findIndex((t) =>
          player?.player?.id != null
            ? t?.player?.id === player.player.id
            : t?.id === player.id
        )
    )
    .sort((a, b) => (a.jersey_number || 0) - (b.jersey_number || 0));
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography>{title}</Typography>
      <Box 
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxHeight: "120px",
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.2)",
            borderRadius: "4px",
          },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${maxPlayersPerRow}, minmax(60px, 1fr))`,
            gap: 1,
            width: "fit-content",
            minWidth: "100%",
          }}
        >
          {uniquePlayers
            .slice(0, maxDisplayedPlayers)
            .map((player: RosterPlayer) => (
              <JerseyIcon
                key={player.id}
                number={player.jersey_number}
                name={player.player.name}
                onClick={() => handlePlayerSelection(player)}
                selected={
                  Array.isArray(selectedPlayer)
                    ? selectedPlayer.some((p) => p.id === player.id)
                    : selectedPlayer?.id === player.id
                }
              />
            ))}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          type="number"
          label="Jersey Number"
          value={jerseyNumber}
          fullWidth
          onChange={handleJerseyNumberChange}
          inputProps={{
            min: 0,
            max: 99,
            step: 1,
          }}
        />
      </Box>
    </Box>
  );
};
